// import React, { useState } from 'react';

// const Downloadbrochure = () => {
//   const [showModal, setShowModal] = useState(false);
//   const [downloadUrl, setDownloadUrl] = useState('');

//   const handleDownloadClick = (e, url) => {
//     e.preventDefault(); // Stop the direct download
//     setDownloadUrl(url);
//     setShowModal(true); // Show the modal
//   };

//   const confirmDownload = () => {
//     setShowModal(false);
//     // Create a hidden link and trigger download
//     const link = document.createElement('a');
//     link.href = downloadUrl;
//     link.setAttribute('download', '');
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <>
//       {/* Breadcrumbs */}
//       <div className="breadcrumbs overlay">
//         <div className="container">
//           <div className="bread-inner">
//             <div className="row">
//               <div className="col-12">
//                 <h2>Download Center</h2>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Brochure Download Buttons */}
//       <div className='py-5 text-center row p-0 g-0'>
//         <div className='col-12 col-md-3 '>
//           <a href="/img/User-Manual-Brochure.pdf" className="download-brochure-btn fs-5 py-5" onClick={(e) => handleDownloadClick(e, '/img/User-Manual-Brochure.pdf')}>
//              User Manual <br />
//           </a>
//         </div>
//         <div className='col-12 col-md-3 '>
//           <a href="/img/Broucher-of-Patient-Warming-Blanket.pdf" className="download-brochure-btn fs-5" onClick={(e) => handleDownloadClick(e, '/img/Broucher-of-Patient-Warming-Blanket.pdf')}>
//              Patient Warming <br /> Blanket Brochure
//           </a>
//         </div>
//         <div className='col-12 col-md-3 '>
//           <a href="/img/Brochure-of-Forced-Air-Patient-Warming-Machine.pdf" className="download-brochure-btn fs-5" onClick={(e) => handleDownloadClick(e, '/img/Brochure-of-Forced-Air-Patient-Warming-Machine.pdf')}>
//              Forced Air Patient <br /> Warming Brochure
//           </a>
//         </div>
//         <div className='col-12 col-md-3  '>
//           <a href="/img/Service-manual.pdf" className="download-brochure-btn fs-5 py-5" onClick={(e) => handleDownloadClick(e, '/img/Service-manual.pdf')}>
//            Wallabies Warmer 
//           </a>
//         </div>

//   <div className='col-12 col-md-3 py-5 d-none pt-5'>
//           <a href="/images/Wallabies-Warm-Care.pdf" className="download-brochure-btn fs-5 pt-5 py-5" onClick={(e) => handleDownloadClick(e, '/images/Wallabies-Warm-Care.pdf')}>
//            Wallabies Warm Care 
//           </a>
//         </div>

      

        
//       </div>

//       {/* Modal */}
//       {showModal && (
//         <div className="modal-backdrop">
//           <div className="modal-box">
//             <h4>Please confirm to download</h4>
//             <p>Provide your name and email (optional) before download:</p>
//             {/* Optional form fields */}
//             <input type="text" placeholder="Name" className="form-control mb-2" />
//             <input type="email" placeholder="Email" className="form-control mb-3" />
//             <button className="btn btn-primary me-2" onClick={confirmDownload}>Download</button>
//             <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
//           </div>
//         </div>
//       )}

//       {/* Basic modal styling */}
//       <style>{`
//         .modal-backdrop {
//           position: fixed;
//           top: 0; left: 0;
//           width: 100%; height: 100%;
//           background: rgba(0, 0, 0, 0.6);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 1050;
//         }
//         .modal-box {
//           background: #fff;
//           padding: 20px;
//           border-radius: 8px;
//           width: 300px;
//         }
//       `}</style>
//     </>
//   );
// };

// export default Downloadbrochure;

import React, { useState } from 'react';

const Downloadbrochure = () => {
  const [showModal, setShowModal] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState('');

  const handleDownloadClick = (e, url) => {
    e.preventDefault();
    setDownloadUrl(url);
    setShowModal(true);
  };

  const confirmDownload = () => {
    setShowModal(false);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', '');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {/* Breadcrumbs */}
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>Download Center</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Brochure Download Buttons */}
      <div className="container py-5">
        <div className="row g-4 text-center">

          <div className="col-12 col-md-3 d-flex">
            <a
              href="/img/User-Manual-Brochure.pdf"
              className="download-brochure-btn fs-5 brochure-btn"
              onClick={(e) =>
                handleDownloadClick(e, '/img/User-Manual-Brochure.pdf')
              }
            >
              User Manual
            </a>
          </div>

          <div className="col-12 col-md-3 d-flex">
            <a
              href="/img/Broucher-of-Patient-Warming-Blanket.pdf"
              className="download-brochure-btn fs-5 brochure-btn"
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  '/img/Broucher-of-Patient-Warming-Blanket.pdf'
                )
              }
            >
              Patient Warming <br /> Blanket Brochure
            </a>
          </div>

          <div className="col-12 col-md-3 d-flex">
            <a
              href="/img/Brochure-of-Forced-Air-Patient-Warming-Machine.pdf"
              className="download-brochure-btn fs-5 brochure-btn"
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  '/img/Brochure-of-Forced-Air-Patient-Warming-Machine.pdf'
                )
              }
            >
              Forced Air Patient <br /> Warming Brochure
            </a>
          </div>

          <div className="col-12 col-md-3 d-flex">
            <a
              href="/img/Service-manual.pdf"
              className="download-brochure-btn fs-5 brochure-btn"
              onClick={(e) =>
                handleDownloadClick(e, '/img/Service-manual.pdf')
              }
            >
              Wallabies Warmer
            </a>
          </div>

        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-backdrop-custom">
          <div className="modal-box">
            <h4>Please confirm to download</h4>
            <p>Provide your name and email (optional) before download:</p>

            <input
              type="text"
              placeholder="Name"
              className="form-control mb-2"
            />
            <input
              type="email"
              placeholder="Email"
              className="form-control mb-3"
            />

            <button className="btn btn-primary me-2" onClick={confirmDownload}>
              Download
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Styles */}
      <style>{`
        .brochure-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;

          width: 100%;
          min-height: 180px;
          padding: 20px;

          border: 2px solid #0d6efd;
          border-radius: 10px;
          text-decoration: none;
          font-weight: 600;
          color: #0d6efd;

          transition: all 0.3s ease;
        }

        .brochure-btn:hover {
          background-color: #0d6efd;
          color: #fff;
          transform: translateY(-4px);
        }

        .modal-backdrop-custom {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1050;
        }

        .modal-box {
          background: #fff;
          padding: 25px;
          border-radius: 10px;
          width: 320px;
          text-align: center;
        }
      `}</style>
    </>
  );
};

export default Downloadbrochure;
